module.exports = __webpack_public_path__ + "img/register.b1091ba9.svg";